module.exports = __webpack_public_path__ + "img/red_bg.1fb3f09e.png";